export const themeLabels = {
  light: 'Modo claro',
  dark: 'Modo escuro',
  default: 'Automático',
}
